import React,{useState, useEffect, useContext, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Cookies from 'js-cookie';

import { toAbsoluteUrl } from '../../../_template/helpers/CommonFunction';

import ValidationMessage from '../../component/common/ValidationMessage';
import ButtonLoader from '../../component/common/ButtonLoader';
import AlertMessage from '../../component/common/AlertMessage';
import AppContext from '../../routing/AuthContext';
import { safeDecrypt, ValidateEmail } from '../../component/common/Helper';

const SystemLogin = (props) => {
    // return
    const authCtx = useContext( AppContext );
    const api_base_url = process.env.REACT_APP_API_URL;

    // ------------ password shown and hide ------------- //
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }

    // ---------- login submit ------------ //
    const [ loginFormErorr, setLoginFormError ] = useState({});
    const [ loginFormData, setLoginFormData ] = useState({
        username : "", 
        password : "",
    });
    const validateField = (name, value) => {
        let error = "";
        if (name === "username") {
            if (!value) {
                error = "Username is required";
            } 
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        return error;
    };
    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setLoginFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setLoginFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            loginSubmitHandler(event);
        }
    };
    const username = localStorage.getItem('system_username');
    const password = localStorage.getItem('system_password');
    const [isCheckedValue, setIsCheckedValue] = useState(false);
    useEffect(() => {
        const savedUser = Cookies.get('rememberedUserName');
        const savedPass = Cookies.get('rememberedPassword');
        if (savedUser) {
            setIsCheckedValue(true)
            setLoginFormData({
                username : savedUser, 
                password : savedPass
            })
        }
    },[]);

    const handleCheckboxChange = (event) => {
        setIsCheckedValue(event.target.checked);
    };

    const [ loginResponse, setLoginResponse ] = useState({
        res_type : '',
        title : '',
        sub_title : '',
    });
    const [isShowButtonLoader, setIsButtonLoader] = useState(false);
    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in loginFormData) {
            newErrors[key] = validateField(key, loginFormData[key]);
        }
        setLoginFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setIsButtonLoader(true)
            const api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            await axios.post(`${api_base_url}api/system-admin-login`, loginFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setLoginResponse({
                        res_type : 'success',
                        title : 'Authentication verified',
                        sub_title : res.data.message,
                    });
                    setLoginFormError({});
                    localStorage.setItem('system_username' , loginFormData.username);
                    localStorage.setItem('system_password' , loginFormData.password);
                    localStorage.setItem('loginInfo', JSON.stringify(res.data.data.data));
                    if(isCheckedValue){
                        Cookies.set('rememberedUserName', loginFormData.username, { expires: 7 });
                        Cookies.set('rememberedPassword', loginFormData.password, { expires: 7 });
                    }
                    else{
                        Cookies.remove('rememberedUserName');
                        Cookies.remove('rememberedPassword');
                    }
                   
                    setTimeout(() => {
                        authCtx.login({
                            token : res.data.data.token, 
                            type: 'SA',
                        });
                        setLoginFormData({
                            username : "", 
                            password : "" ,
                        });
                    }, 1000);
                } else if(res.data.status === 'error') {
                    setLoginResponse({
                        res_type : 'danger',
                        title : 'Authentication Failed',
                        sub_title : res.data.message,
                    })
                }
            })
            .catch((error) => {
                console.error(error);
            })
            setIsButtonLoader(false)
        }
    }
    // for reset password
    const [showResetForm, setShowResetForm] = useState(false);
    const [showOtpForm, setShowOtpForm] = useState(false);
    const [newPasswordForm, setNewPasswordForm] = useState(false);

    const [otpToken, setOtpToken] = useState(null);
    const [resetFormData, setResetFormData] = useState({
        userEmail : "", 
        isValid : true,
        user_type: "SA"
    });
    const [newPasswordFormData, setNewPasswordFormData] = useState({
        new_password: '',
        confirm_password : "", 
        isValidNewPassword : true,
        isValidNewConfirmPassword : true,
        user_name: '',
        user_type: 'SA'
    });
    const [verificationValus, setVerificationValus] = useState(['', '', '', '', '']);
    const [newPasswordShown, setNewPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

    const handelEmail = (text) => {
        if(text.target.value) {
            setResetFormData({
                userEmail : text.target.value, 
                isValid : ValidateEmail(text.target.value),
                user_type: 'SA'
            });
        } else {
            setResetFormData({
                userEmail : '', 
                isValid : false
            })
        }
    }
    const sendOTP = async() => {
        if(resetFormData.userEmail) {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            await axios.post(`${api_base_url}api/check-login-email`, resetFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    const _token = res.data.data._token
                    const decrypted = safeDecrypt({
                        encryptedData : _token,
                        base64Key : 'gT#7@uZ$9LmR8qV1',
                        base64Iv : 'X7r#zP@9gL!q1VbT'
                    });
                    setOtpToken(decrypted);
                    setShowOtpForm(true);
                } else if(res.data.status === 'error') {
                    setLoginResponse({
                        res_type : 'danger',
                        title : 'Authentication Failed',
                        sub_title : res.data.message,
                    })
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } else {
            setResetFormData({
                userEmail : '', 
                isValid : false
            })
        }
    }
    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];
    const handleChange = (e, index) => {
        const value = e.target.value;

        if (!/^\d?$/.test(value)) return;

        const newValues = [...verificationValus];
        newValues[index] = value;
        setVerificationValus(newValues);


        if (value && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };
    const handleKeyDownOTP = (e, index) => {
        if (e.key === 'Backspace' && !verificationValus[index] && index > 0) {
            const newValues = [...verificationValus];
            newValues[index - 1] = '';
            setVerificationValus(newValues);
            inputRefs[index - 1].current.focus();
        }
    };
    const validedOtp = () => {
        const enteredValue = verificationValus.join('');
        if(enteredValue === otpToken) {
            setNewPasswordForm(true);
            setLoginResponse({
                res_type : '',
                title : '',
                sub_title : "",
            })
        } else {
            setLoginResponse({
                res_type : 'danger',
                title : 'Authentication Failed',
                sub_title : "OTP not match",
            })
        }
    }
    const newPasswordInputChangeHandler = (text) => {
        if(text.target.value){
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                new_password: text.target.value.trim(),
                isValidNewPassword: true,
            }));
        } else {
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                new_password: '',
                isValidNewPassword: false,
            }));
        }
    }
    const confirmPasswordInputChangeHandler = (text) => {
        if(text.target.value){
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                confirm_password: text.target.value.trim(),
                isValidNewConfirmPassword: true,
            }));
        } else {
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                confirm_password: '',
                isValidNewConfirmPassword: false,
            }));
        }
    }
    const toggleNewPasswordVisibility = () => {
        setNewPasswordShown(!newPasswordShown)
    }
    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordShown(!confirmPasswordShown)
    }
    const newPasswordSubmit = async() => {
        if(newPasswordFormData.new_password != '' && newPasswordFormData.confirm_password != '') {
            if((newPasswordFormData.new_password === newPasswordFormData.confirm_password) && resetFormData.userEmail) {
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                    }
                };
                newPasswordFormData.user_name = resetFormData.userEmail;
                await axios.post(`${api_base_url}api/new-password-generate`, newPasswordFormData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setLoginResponse({
                            res_type : 'success',
                            title : 'Password Reset',
                            sub_title : "Password successfully reset",
                        })
                        setTimeout(() => {
                            setShowResetForm(false);
                            setShowOtpForm(false);
                            setNewPasswordForm(false);

                            setLoginResponse({
                                res_type : '',
                                title : '',
                                sub_title : "",
                            })
                        }, 1000);
                    } else if(res.data.status === 'error') {
                        setLoginResponse({
                            res_type : 'danger',
                            title : 'Authentication Failed',
                            sub_title : res.data.message,
                        })
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            } else {
                setLoginResponse({
                    res_type : 'danger',
                    title : 'Authentication Failed',
                    sub_title : "Confirm password are not match with new password",
                });
            }
        } else {
            if(newPasswordFormData.new_password.trim() == '') {
                setNewPasswordFormData((prevData) => ({
                    ...prevData,
                    isValidNewPassword: false,
                }));
            }

            if(newPasswordFormData.confirm_password == '') {
                setNewPasswordFormData((prevData) => ({
                    ...prevData,
                    isValidNewConfirmPassword: false,
                }));
            }
        }   
    }

    return (
        <>
            {/* ============ new =========== */}
            <div className="d-flex flex-column flex-root min-vh-100" style={{background:'white'}}>
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                            <div className="w-lg-500px p-10">
                                <form className="form w-100">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-center mb-11">
                                                <h1 className="text-dark fw-bolder mb-3 fs-2x">Sign In</h1>
                                                <div className="text-gray-500 fw-semibold fs-3">
                                                    Let's step into system admin
                                                </div>
                                            </div>
                                        </div>
                                        {loginResponse.res_type != '' &&
                                            <div className='col-md-12'>
                                                <AlertMessage
                                                    type = {loginResponse.res_type}
                                                    title = {loginResponse.title}
                                                    sub_title = {loginResponse.sub_title}
                                                    border_type='dashed'
                                                />
                                            </div>
                                        }
                                        {!showResetForm && <>
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <input 
                                                    type="text" 
                                                    placeholder="User Name" 
                                                    name="username" 
                                                    autoComplete="off" 
                                                    className={`form-control bg-transparent ${loginFormErorr.username ? 'is-invalid' : ''}`}
                                                    style={{ height: '50px' }}
                                                    onChange={inputChangeHandler}
                                                    value={loginFormData.username}
                                                    onKeyDown={handleKeyDown}
                                                />
                                                {loginFormErorr.username && <ValidationMessage className='text-danger' message ={loginFormErorr.username}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <div className="position-relative">
                                                    <input 
                                                        className={`form-control bg-transparent ${!passwordShown ? 'inp-secure' : ''} ${loginFormErorr.password ? 'is-invalid' : ''}`}
                                                        type="text" 
                                                        placeholder="Password" 
                                                        name="password" 
                                                        autoComplete="off" 
                                                        style={{ height: '50px' }}
                                                        onChange={inputChangeHandler}
                                                        value={loginFormData.password}
                                                        onKeyDown={handleKeyDown}
                                                    />
                                                    {!loginFormErorr.password && 
                                                        <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                            { !passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEye} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                            { passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEyeSlash} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                {loginFormErorr.password && <ValidationMessage className='text-danger' message ={loginFormErorr.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-11">
                                            <label className="form-check form-check-sm form-check-custom form-check-solid me-5 mb-8">
                                                <input className="form-check-input" type="checkbox" checked={isCheckedValue} onChange={handleCheckboxChange}  />
                                                <span className="form-check-label">Remember for next time</span>
                                            </label>
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <div className="d-grid mb-10">
                                                <button 
                                                    className={`btn btn-primary ${isShowButtonLoader && 'disabled'}`} 
                                                    type="button"
                                                    onClick={loginSubmitHandler}
                                                >
                                                    {
                                                        isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : <span className="indicator-label">Let's Go</span>
                                                    }
                                                </button>
                                            </div>
                                            <span className="form-check-label">Don't remember password ?<span className="link-primary cursor-pointer" onClick={()=>setShowResetForm(true)}> Reset Now</span></span>
                                        </div>
                                        </>}

                                        {showResetForm && !showOtpForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <input
                                                            type="email" 
                                                            placeholder="Enter your email" 
                                                            name="usernameEmail" 
                                                            autoComplete="off" 
                                                            className={`form-control bg-transparent ${!resetFormData.isValid ? 'is-invalid' : ''}`}
                                                            style={{ height: '50px' }}
                                                            onChange={handelEmail}
                                                            value={resetFormData.userEmail}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={sendOTP}>Send OTP</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {showOtpForm && !newPasswordForm && 
                                            <>
                                                <div className='col-md-12'>
                                                    <div className="mb-10">
                                                        <div className="fw-bold text-start text-dark fs-6 mb-1 ms-1">
                                                            Enter your 5 digit verification code
                                                        </div>
                                                        <div className="d-flex flex-wrap">
                                                            {inputRefs.map((ref, index) => (
                                                                <input
                                                                    className="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-2 my-2"
                                                                    key={index}
                                                                    type="text"
                                                                    maxLength="1"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    ref={ref}
                                                                    onChange={(e) => handleChange(e, index)}
                                                                    onKeyDown={(e) => handleKeyDownOTP(e, index)}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={validedOtp}>Valided OTP</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {newPasswordForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!newPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="New Password" 
                                                                name="new_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={newPasswordInputChangeHandler}
                                                                value={newPasswordFormData.new_password}
                                                            />
                                                            {newPasswordFormData.new_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                { !newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEye} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                                { newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEyeSlash} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                            </span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!confirmPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewConfirmPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="new Confirm Password" 
                                                                name="new_confirm_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={confirmPasswordInputChangeHandler}
                                                                value={newPasswordFormData.confirm_password}
                                                            />
                                                            {newPasswordFormData.confirm_password && 
                                                                <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                    { !confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEye} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                    { confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEyeSlash} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={newPasswordSubmit}>Submit</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2" style={{backgroundImage: `linear-gradient(312deg, #ebecf8ff 11.58%, #eaeeffff 82.42%)`}}>
                        <div className="d-flex flex-column flex-center py-7 py-lg-15 w-100">
                            <div className="mb-0 mb-lg-12">
                                <img alt="Logo" src="/truvoice_logo-new.png" className="h-60px h-lg-75px"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ============= old ============== */}
            <div className="d-flex flex-column flex-root d-none" id="sai_app_root">
                <div className="d-flex m-auto justify-content-center align-items-center vh-100">
                    <div className="d-flex flex-lg-row-fluid">
                        <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                            <img className="theme-light-show mw-100 w-lg-400px mb-10 mb-lg-20" src={toAbsoluteUrl('media/auth/tvsaibot.png')} alt='' />
                            <h1 className="text-gray-800 fs-2qx fw-bold text-center mb-7">You’ve Arrived at system admin </h1>
                            <div className="text-gray-600 fs-base text-center fw-semibold">In this kind of post,
                            <a href="#" className="opacity-75-hover text-primary me-1">the blogger</a>introduces a person they’ve interviewed
                            <br />and provides some background information about
                            <a href="#" className="opacity-75-hover text-primary me-1">the interviewee</a>and their
                            <br />work following this is a transcript of the interview.</div>
                        </div>
                    </div>
                    <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                        <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10">
                            <div className="w-md-400px">
                                <form className="form w-100">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-center mb-11">
                                                <h1 className="text-dark fw-bolder mb-3 fs-2x">Sign In</h1>
                                                <div className="text-gray-500 fw-semibold fs-3">
                                                    Let's step into system admin
                                                </div>
                                            </div>
                                        </div>
                                        {loginResponse.res_type != '' &&
                                            <div className='col-md-12'>
                                                <AlertMessage
                                                    type = {loginResponse.res_type}
                                                    title = {loginResponse.title}
                                                    sub_title = {loginResponse.sub_title}
                                                    border_type='dashed'
                                                />
                                            </div>
                                        }
                                        {!showResetForm && <>
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <input 
                                                    type="text" 
                                                    placeholder="User Name" 
                                                    name="username" 
                                                    autoComplete="off" 
                                                    className={`form-control bg-transparent ${loginFormErorr.username ? 'is-invalid' : ''}`}
                                                    style={{ height: '50px' }}
                                                    onChange={inputChangeHandler}
                                                    value={loginFormData.username}
                                                    onKeyDown={handleKeyDown}
                                                />
                                                {loginFormErorr.username && <ValidationMessage className='text-danger' message ={loginFormErorr.username}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="fv-row mb-8">
                                                <div className="position-relative">
                                                    <input 
                                                        className={`form-control bg-transparent ${!passwordShown ? 'inp-secure' : ''} ${loginFormErorr.password ? 'is-invalid' : ''}`}
                                                        type="text" 
                                                        placeholder="Password" 
                                                        name="password" 
                                                        autoComplete="off" 
                                                        style={{ height: '50px' }}
                                                        onChange={inputChangeHandler}
                                                        value={loginFormData.password}
                                                        onKeyDown={handleKeyDown}
                                                    />
                                                    {!loginFormErorr.password && 
                                                        <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                            { !passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEye} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                            { passwordShown && 
                                                                <FontAwesomeIcon 
                                                                    icon={faEyeSlash} 
                                                                    className='fs-4 cursor-pointer text-gray-500'
                                                                    onClick={ togglePasswordVisibility }
                                                                />
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                {loginFormErorr.password && <ValidationMessage className='text-danger' message ={loginFormErorr.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-11">
                                            <label className="form-check form-check-sm form-check-custom form-check-solid me-5 mb-8">
                                                <input className="form-check-input" type="checkbox" checked={isCheckedValue} onChange={handleCheckboxChange}  />
                                                <span className="form-check-label">Remember for next time</span>
                                            </label>
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <div className="d-grid mb-10">
                                                <button 
                                                    className={`btn btn-primary ${isShowButtonLoader && 'disabled'}`} 
                                                    type="button"
                                                    onClick={loginSubmitHandler}
                                                >
                                                    {
                                                        isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : <span className="indicator-label">Let's Go</span>
                                                    }
                                                </button>
                                            </div>
                                            <span className="form-check-label">Don't remember password ?<span className="link-primary cursor-pointer" onClick={()=>setShowResetForm(true)}> Reset Now</span></span>
                                        </div>
                                        </>}

                                        {showResetForm && !showOtpForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <input
                                                            type="email" 
                                                            placeholder="Enter your email" 
                                                            name="usernameEmail" 
                                                            autoComplete="off" 
                                                            className={`form-control bg-transparent ${!resetFormData.isValid ? 'is-invalid' : ''}`}
                                                            style={{ height: '50px' }}
                                                            onChange={handelEmail}
                                                            value={resetFormData.userEmail}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={sendOTP}>Send OTP</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {showOtpForm && !newPasswordForm && 
                                            <>
                                                <div className='col-md-12'>
                                                    <div className="mb-10">
                                                        <div className="fw-bold text-start text-dark fs-6 mb-1 ms-1">
                                                            Enter your 5 digit verification code
                                                        </div>
                                                        <div className="d-flex flex-wrap">
                                                            {inputRefs.map((ref, index) => (
                                                                <input
                                                                    className="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-2 my-2"
                                                                    key={index}
                                                                    type="text"
                                                                    maxLength="1"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    ref={ref}
                                                                    onChange={(e) => handleChange(e, index)}
                                                                    onKeyDown={(e) => handleKeyDownOTP(e, index)}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={validedOtp}>Valided OTP</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {newPasswordForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!newPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="New Password" 
                                                                name="new_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={newPasswordInputChangeHandler}
                                                                value={newPasswordFormData.new_password}
                                                            />
                                                            {newPasswordFormData.new_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                { !newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEye} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                                { newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEyeSlash} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                            </span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!confirmPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewConfirmPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="new Confirm Password" 
                                                                name="new_confirm_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={confirmPasswordInputChangeHandler}
                                                                value={newPasswordFormData.confirm_password}
                                                            />
                                                            {newPasswordFormData.confirm_password && 
                                                                <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                    { !confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEye} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                    { confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEyeSlash} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={newPasswordSubmit}>Submit</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SystemLogin